import * as React from "react";
import Listup from "./listup";
import Grants from "./grants";
import { awardData } from "../data";
import { useLang } from "../lang";

const Award: React.FC = () => {
  const { langEn } = useLang();
  return (
    <div id="award" className="container justify-content-center">
      <p className="title">{langEn ? "Awards and Honors" : "受賞 / 競争的資金"}</p>

      <div className="row text-left">
        <Listup items={awardData.academicAwards} title_en="Academic Awards" title_ja="受賞" />
        <Grants
          items={awardData.grant}
          title_en="Grants / Fellowship / Scholarship"
          title_ja="競争的資金 / フェローシップ / 奨学金"
        />
      </div>
    </div>
  );
};

export default Award;
